import React from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import { useSiteSettings } from '../SiteSettingsContext';
import { brandNameFromSettings } from '../siteBrand';

function WhatsAppIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={24} height={24} aria-hidden>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.5.5 0 0 0 .611.611l4.458-1.495A11.945 11.945 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 0 1-5.006-1.37l-.357-.212-2.642.885.885-2.642-.212-.357A9.818 9.818 0 1 1 12 21.818z" />
    </svg>
  );
}

/** Floating Instagram + WhatsApp — fixed bottom-right, storefront only. */
export default function FloatingSocialFab() {
  const { pathname } = useLocation();
  const { settings: site } = useSiteSettings();

  if (pathname.startsWith('/admin')) return null;

  const brandName = brandNameFromSettings(site);
  const instagramUrl = String(site.instagram_url || 'https://instagram.com/floraljewelry_salonidesigns').trim();
  const whatsappHref = String(site.whatsapp_href || 'https://wa.me/919680384332').trim();

  if (!instagramUrl && !whatsappHref) return null;

  const dock = (
    <div className="floating-social-dock" aria-label="Contact us">
      {instagramUrl ? (
        <a
          href={instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="floating-social-dock__btn floating-social-dock__btn--instagram"
          aria-label={`${brandName} on Instagram`}
          title="Instagram"
        >
          <img
            src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/instagram.svg"
            alt=""
            className="floating-social-dock__icon floating-social-dock__icon--instagram"
            width={24}
            height={24}
          />
        </a>
      ) : null}
      {whatsappHref ? (
        <a
          href={whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          className="floating-social-dock__btn floating-social-dock__btn--whatsapp"
          aria-label="Chat on WhatsApp"
          title="WhatsApp us"
        >
          <WhatsAppIcon />
        </a>
      ) : null}
    </div>
  );

  if (typeof document === 'undefined') return dock;

  return createPortal(dock, document.body);
}
